import { type PropsWithChildren } from 'react';

import { Box, Flex } from '@valwin/facto/components';

export function PhonePreview({ children }: PropsWithChildren) {
  return (
    <Flex
      direction="column"
      gap="4"
      width="240px"
      height="502px"
      borderRadius="37px"
      borderWidth="5px"
      borderColor="black"
      overflow="hidden"
      background="white"
      position="relative"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        paddingX={5}
        height="33px"
        flexShrink={0}
        fontSize="10px"
        position="relative"
      >
        {/* Dynamic Island */}
        <Box
          top="7px"
          left={0}
          right={0}
          margin="auto"
          width="84px"
          height="22px"
          background="black"
          borderRadius="12px"
          zIndex={10}
        />
      </Flex>

      <Box flex="1" overflow="auto">
        {children}
      </Box>

      {/* Home indicator */}
      <Box
        position="absolute"
        left={0}
        right={0}
        margin="auto"
        bottom="5px"
        width="80px"
        height="4px"
        background="black"
        borderRadius="20px"
        zIndex={10}
      />
    </Flex>
  );
}
